import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { notificationKeys } from "@/lib/query-keys";

function useInvalidateNotifications() {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: notificationKeys.list });
    qc.invalidateQueries({ queryKey: notificationKeys.unreadCount });
  };
}

/** Marca todas las notificaciones como leídas. */
export function useMarkAllNotificationsRead() {
  const invalidate = useInvalidateNotifications();
  return useMutation({
    mutationFn: () =>
      fetchToBackend("/notifications/read-all", { method: "POST" }),
    onSuccess: invalidate,
  });
}
